import { render } from "./AppView.vue?vue&type=template&id=3c96703d&scoped=true"
import script from "./AppView.vue?vue&type=script&lang=js"
export * from "./AppView.vue?vue&type=script&lang=js"

import "./AppView.vue?vue&type=style&index=0&id=3c96703d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c96703d"]])

export default __exports__